// extracted by mini-css-extract-plugin
export default {"editOption":"EditButton_editOption__I5XLd"};